import { createContext, useContext } from "react";

interface SearchContextProps {
  search: string;
  onChangeSearch: (value: string) => void;
}

export const SearchContext = createContext<SearchContextProps>({
  search: "",
  onChangeSearch: () => null,
});

export const SearchContextProvider = SearchContext.Provider;

export const useSearchContext = (): SearchContextProps =>
  useContext(SearchContext);
